import { BRAND } from '../lib/brand.js'
import { cn } from '../lib/cn.js'

/**
 * The brand mark: the emblem alone, where space is tight — the icon rail, the
 * field app's empty pane. One component with `Lockup` so every place the
 * artwork appears reads it from `BRAND.artwork`. See ADR 006 and ADR 024.
 *
 * `onDark` draws the reversed artwork, whose navy is white, for navy and dark
 * backgrounds. Size it with a width class; the height follows the artwork.
 */
export function Wordmark({ onDark = false, className }: { onDark?: boolean; className?: string }) {
  return (
    <img
      src={onDark ? BRAND.artwork.emblemReversed : BRAND.artwork.emblem}
      alt={BRAND.name}
      draggable={false}
      className={cn('block h-auto w-8 shrink-0 select-none', className)}
    />
  )
}

/**
 * The horizontal lockup: emblem and wordmark as one piece of artwork.
 *
 * `tagline` keeps "Pest Control Professionals" under the name; the guide drops
 * it below 200px wide, so it is off unless the lockup is drawn at least that
 * wide. Never draw it under 120px — use `Wordmark` there.
 */
export function Lockup({
  onDark = false,
  tagline = false,
  className,
}: {
  onDark?: boolean
  tagline?: boolean
  className?: string
}) {
  const { artwork } = BRAND
  const src = tagline
    ? onDark
      ? artwork.horizontalReversed
      : artwork.horizontal
    : onDark
      ? artwork.compactReversed
      : artwork.compact

  return (
    <img
      src={src}
      alt={BRAND.name}
      draggable={false}
      className={cn('block h-auto w-[160px] max-w-full shrink-0 select-none', className)}
    />
  )
}
